export var UserRole;
(function (UserRole) {
    UserRole["ANONYMOUS"] = "ANONYMOUS";
    UserRole["USER"] = "USER";
    UserRole["VENUE_ADMIN"] = "VENUE_ADMIN";
    UserRole["SITE_ADMIN"] = "SITE_ADMIN";
    UserRole["SUPER_ADMIN"] = "SUPER_ADMIN";
})(UserRole || (UserRole = {}));
export const DISTANCE_UNITS = ['mi', 'km'];
